/* global axios */
import ApiClient from '../ApiClient';

// Số liệu hiệu suất nhân viên trực page. Endpoint riêng của BonBoZ chứ không
// dùng `/summary_reports/agent`: endpoint đó trộn hai rổ số liệu nên "Số hội
// thoại 19" đứng cạnh "Đã lấy số 51". Lý do đầy đủ ghi ở
// `app/builders/bonboz/hieu_suat_nhan_vien_builder.rb`.
class HieuSuatAPI extends ApiClient {
  constructor() {
    super('bonboz/hieu_suat', { accountScoped: true, apiVersion: 'v2' });
  }

  // `inboxIds` la bo loc TRANG dang chon o bang dieu khien. Mang rong = tat ca,
  // va axios bo han tham so khi mang rong nen backend nhan duoc dung nhu vay.
  // `gom`: 'nhan_vien' | 'thoi_gian' — hai tab cua bang "Thong ke chi tiet".
  // Tab thoi gian cat ngay theo mui gio nguoi xem nen phai gui `timezone_offset`.
  nhanVien({ since, until, inboxIds, gom } = {}) {
    return axios.get(`${this.url}/nhan_vien`, {
      params: {
        since,
        until,
        inbox_ids: inboxIds,
        gom,
        timezone_offset: -new Date().getTimezoneOffset() / 60,
      },
    });
  }

  trang({ since, until, inboxIds } = {}) {
    return axios.get(`${this.url}/trang`, {
      params: { since, until, inbox_ids: inboxIds },
    });
  }

  // Ca trang Tong quan trong MOT luot goi. Can `timezone_offset` vi payload co
  // ca chuoi theo ngay lan bieu do "theo gio trong ngay" — cat o may chu theo
  // UTC thi dinh gio trua hien ra luc 5 gio sang.
  tongQuan({ since, until, inboxIds } = {}) {
    return axios.get(`${this.url}/tong_quan`, {
      params: {
        since,
        until,
        inbox_ids: inboxIds,
        timezone_offset: -new Date().getTimezoneOffset() / 60,
      },
    });
  }

  // Bang "Thong ke chi tiet": mot dong moi ngay. Phai gui `timezone_offset` —
  // cat ngay o may chu theo UTC thi o Viet Nam moi tin sau 7 gio toi roi sang
  // ngay hom sau. Cung quy uoc voi `/reports` cua upstream (`api/reports.js`).
  theoNgay({ since, until, inboxIds, gom } = {}) {
    return axios.get(`${this.url}/theo_ngay`, {
      params: {
        since,
        until,
        inbox_ids: inboxIds,
        // 'ngay' | 'gio' — hai tab cua bang "Thong ke chi tiet".
        gom,
        timezone_offset: -new Date().getTimezoneOffset() / 60,
      },
    });
  }

  // Trang Tuong tac. `gom`: 'thoi_gian' | 'nhan_vien'; `gomGio`: 'ngay' | 'gio'
  // (chi co nghia o tab thoi gian).
  tuongTac({ since, until, inboxIds, gom, gomGio } = {}) {
    return axios.get(`${this.url}/tuong_tac`, {
      params: {
        since,
        until,
        inbox_ids: inboxIds,
        gom,
        gom_gio: gomGio,
        timezone_offset: -new Date().getTimezoneOffset() / 60,
      },
    });
  }

  // Trang The hoi thoai. `gom`: 'ngay' (theo khoang da chon) | 'gio' (hom nay).
  the({ since, until, inboxIds, gom } = {}) {
    return axios.get(`${this.url}/the`, {
      params: {
        since,
        until,
        inbox_ids: inboxIds,
        gom,
        timezone_offset: -new Date().getTimezoneOffset() / 60,
      },
    });
  }

  // Trang Tong dai. `gom`: 'ngay' | 'gio' — do min cua bieu do va bang thoi gian.
  tongDai({ since, until, inboxIds, gom } = {}) {
    return axios.get(`${this.url}/tong_dai`, {
      params: {
        since,
        until,
        inbox_ids: inboxIds,
        gom,
        timezone_offset: -new Date().getTimezoneOffset() / 60,
      },
    });
  }

  // Trang Danh gia. Nguon la CSAT cua chinh Chatwoot.
  danhGia({ since, until, inboxIds } = {}) {
    return axios.get(`${this.url}/danh_gia`, {
      params: {
        since,
        until,
        inbox_ids: inboxIds,
        timezone_offset: -new Date().getTimezoneOffset() / 60,
      },
    });
  }

  // Thong ke quang cao: cay campaign/adset/ad + ti le ra so + cam xuc theo ad.
  quangCao({ since, until, inboxIds } = {}) {
    return axios.get(`${this.url}/quang_cao`, {
      params: {
        since,
        until,
        inbox_ids: inboxIds,
        timezone_offset: -new Date().getTimezoneOffset() / 60,
      },
    });
  }

  // Thong ke cam xuc: tong theo nhan, chuoi theo ngay (can timezone_offset,
  // cung ly do voi theoNgay), va bang "ai phu trach khach tieu cuc".
  camXuc({ since, until, inboxIds } = {}) {
    return axios.get(`${this.url}/cam_xuc`, {
      params: {
        since,
        until,
        inbox_ids: inboxIds,
        timezone_offset: -new Date().getTimezoneOffset() / 60,
      },
    });
  }

  // Danh sach tung tin cua mot nhan cam xuc — cho bang chi tiet va file Excel.
  camXucChiTiet({ label, since, until, inboxIds, page, perPage } = {}) {
    return axios.get(`${this.url}/cam_xuc_chi_tiet`, {
      params: {
        label,
        since,
        until,
        inbox_ids: inboxIds,
        page,
        per_page: perPage,
      },
    });
  }

  // So "ngay luc nay" (dang cho / chua ai nhan), loc theo trang dang chon.
  hienTai({ inboxIds } = {}) {
    return axios.get(`${this.url}/hien_tai`, {
      params: { inbox_ids: inboxIds },
    });
  }
}

export default new HieuSuatAPI();
